import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FilterBar from '@blade-sxp/search-center/pages/components/event-result/filter-bar.vue';
import { eventTypes, allTrack, getSearchType, trackSpace, deleteTrack } from '@blade-sxp/search-center/api/index';
import VirtualList from '@blade/common/components/virtual-list/index.vue';
import { isEmpty } from 'lodash';
import ContainImg from '@blade-sxp/search-center/pages/components/contain-img.vue';
import langMsg from '@blade-sxp/search-center/lang/index';
import DetailsPage from '@blade/common/pages/result-details/index.vue';
import moment from 'moment';
import { searchStore } from '@blade-sxp/search-center/store/search';
let AlarmCenter = class AlarmCenter extends Vue {
    currentPage = 1;
    itemSize = {
        height: 230,
        width: 166, // 卡片宽度，宽度和lineSize不传默认每行展示4个卡片
    };
    spacing = [24, 24]; // 上下左右边距
    isPagination = false; // 是否滚动加载
    eventList = []; // 事件列表
    total = 0; // 总数列表
    pageSizes = 72; // 每页72条数据
    incidentTypes = []; // 事件参数
    deviceList = []; // 设备列表:
    openDetail = false; // 详情弹窗
    detailsIndex = 0; // 详情索引
    checkRoute = false;
    selectedImg = [];
    screenWidth = 0;
    screenHeight = 0;
    isShow = false;
    distance = '';
    imagePage = {};
    tagIndex = 0;
    timeData = [];
    pageNum = 1;
    imageName = '';
    allNum = 0;
    top = 203;
    routeType = '';
    deviceData = [];
    deviceNames = [];
    loading = false;
    langeName = false;
    isClose = false;
    linkList = [];
    defaultEvent = []; // 默认展示第一个事件
    showPath = true;
    // 轨迹ID删除 同步页面
    changeIdempotentId(imageId) {
        let i = this.eventList.find((item) => item.idempotentId === imageId);
        i > -1 && (this.eventList[i].existsUserTrack = false);
        this.getAllcount();
    }
    // 打开详情框
    onImgClick(val) {
        this.openDetail = true;
        this.detailsIndex = val.idIndex;
    }
    next() {
        this.detailsIndex++;
    }
    prev() {
        this.detailsIndex--;
    }
    closeDetails() {
        this.openDetail = false;
    }
    // 点击分页
    current(page) {
        this.currentPage = page;
        this.parameters();
        // this.$emit('pageSize', page);
    }
    getTypeValue(val) {
        let newArr = val.slice(-1);
        if (newArr[0] === 'null') {
            newArr = [];
        }
        return newArr;
    }
    showBtn(btnPath) {
        this.showPath = btnPath;
    }
    // 初始进入
    initialParameters() {
        let param = {};
        if (this.$route.params.param) {
            param = JSON.parse(this.$route.params.param);
            this.$refs.filterBar.form.eventTypes = param.incidentTypeSearchRequest.incidentTypes; // 子组件事件回显
            this.$refs.filterBar.form.dates = [param.dateStart, param.dateEnd]; // 子组件时间回显
            this.$refs.filterBar.form.device = param.deviceIdList; // 子组件设备回显
            this.$refs.filterBar.labelList = param.deviceIdList; // 子组件设备回显
            let deviceTag = '';
            if (param.deviceIdList.length > 1) {
                deviceTag = `${this.$t('multiple')}`;
            }
            this.$refs.filterBar.tagList.push(param.incidentTypeSearchRequest.incidentTypes.toString(), [param.dateStart, param.dateEnd].toString(), deviceTag); // 子组件设备回显
            let filterEventType = this.getTypeValue(param.incidentTypeSearchRequest.incidentTypes) || [];
            param.incidentTypeSearchRequest.incidentTypes = [filterEventType[filterEventType.length - 1]];
            this.incidentTypes = param.incidentTypeSearchRequest.incidentTypes;
            this.timeData = [param.dateStart, param.dateEnd];
            this.deviceList = param.deviceIdList;
        }
        else {
            this.defaultArr(this.linkList);
            let filterEventType = this.getTypeValue(this.defaultEvent) || [];
            this.$refs.filterBar.form.eventTypes = this.defaultEvent; // 默认事件回显第一个
            this.incidentTypes = [filterEventType[filterEventType.length - 1]]; // 默认传参第一个
            this.timeData = [moment().subtract('days', 1).format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')];
        }
        this.parameters();
    }
    // 事件默认选中第一个数据
    defaultArr(arr) {
        arr.map((item, index) => {
            if (index === 0) {
                this.defaultEvent.push(item.value);
                if (item.children) {
                    this.defaultArr(item.children);
                }
            }
        });
    }
    // 搜索接口
    search(param) {
        eventTypes(param)
            .then((res) => {
            this.eventList = res.searchList[0].list;
            this.eventList.forEach((item, idx) => {
                item.idIndex = idx;
            });
            this.total = res.searchList[0].total;
        })
            .catch(() => {
            this.loading = false;
        });
    }
    // 搜索参数
    parameters() {
        let data = {
            page: this.currentPage,
            size: 72,
            dateEnd: this.timeData[1],
            dateStart: this.timeData[0],
            deviceIdList: this.deviceList,
            incidentTypeSearchRequest: {
                incidentTypes: this.incidentTypes,
            },
        };
        this.search(data);
    }
    // 设备筛选
    deviceChange(device) {
        this.deviceList = device;
        this.currentPage = 1;
        this.parameters();
    }
    // 时间筛选
    pickerTime(time) {
        this.timeData = time;
        this.currentPage = 1;
        this.parameters();
    }
    // 事件筛选
    eventChange(val) {
        this.incidentTypes = val;
        this.currentPage = 1;
        this.parameters();
    }
    clickRoute(img) {
        if (!img.existsUserTrack) {
            if (this.allNum === 50) {
                return this.$message.error(this.$t('track'));
            }
            return this.addRoute(img);
        }
        this.deletedRoute(img);
    }
    // 添加轨迹
    addRoute(img) {
        const params = {
            ...img,
            trackType: this.incidentTypes.toString(),
        };
        // this.detailLoading = true;
        trackSpace(params)
            .then((res) => {
            let i = this.eventList.findIndex((item) => item.imageFeature.eventRecordId === img.imageFeature.eventRecordId);
            this.eventList[i].existsUserTrack = true;
            this.showPath = false;
            this.getAllcount();
        })
            .finally(() => {
            // this.detailLoading = false;
        });
    }
    // 删除轨迹
    deletedRoute(img) {
        const route = this.eventList.find((e) => e.idempotentId === img.idempotentId);
        if (!route)
            return;
        this.deleteRoute(route, img);
    }
    deleteRoute(imageId, img) {
        // this.detailLoading = true;
        const route = this.selectedImg.find((e) => e.idempotentId === imageId.idempotentId);
        deleteTrack(Number(route.id))
            .then((res) => {
            this.getAllcount();
            let i = this.eventList.findIndex((item) => item.idempotentId === imageId.idempotentId);
            this.eventList[i].existsUserTrack = false;
            this.showPath = true;
        })
            .finally(() => {
            // this.detailLoading = false;
        });
    }
    created() {
        this.getEvent();
        this.getAllcount();
    }
    mounted() {
        this.screenWidth = this.$refs['result'].offsetWidth;
        this.screenHeight = document.documentElement.clientHeight - 167;
        window.addEventListener('scroll', this.handleScrollx, true);
    }
    closeTrack(bool) {
        this.isClose = bool;
    }
    filter() {
        this.isShow = !this.isShow;
    }
    // 获取总轨迹
    getAllcount() {
        allTrack().then((res) => {
            if (res) {
                this.allNum = res.length;
                this.selectedImg = res;
                searchStore.updateSelectedImg(this.selectedImg);
            }
        });
    }
    handleScrollx(e) {
        const elm = e.target;
        if (elm.className === 'infinite-list-container') {
            const top = elm.scrollTop;
            if (top <= this.top) {
                this.isShow = false;
                this.distance = '';
            }
            else {
                this.isShow = true;
                this.distance = 'distance';
            }
        }
    }
    getAllTrack(num) {
        this.allNum = num;
    }
    trackNum(num, data) {
        this.allNum = num;
        if (!num) {
            this.eventList.forEach((item) => {
                item.existsUserTrack = false;
            });
        }
        else {
            let i = this.eventList.findIndex((item) => item.idempotentId === data.idempotentId);
            if (i !== -1) {
                this.eventList[i].existsUserTrack = false;
            }
        }
        this.getAllcount();
    }
    isCheck(val) {
        this.checkRoute = val;
    }
    getEvent() {
        getSearchType({ key: 'searchCenter' }).then((res) => {
            this.linkList = this.treeCustomName(res);
            this.initialParameters();
        });
    }
    // 修改成联级选择器符合的格式
    treeCustomName = (tree) => {
        const deep = (datas) => {
            if (!isEmpty(datas)) {
                const data = datas.map((item) => {
                    return {
                        value: item?.labels[0]?.code,
                        label: item?.labels[0]?.name,
                        children: item?.subAttributes && item?.subAttributes?.length > 0 ? deep(item.subAttributes) : null,
                    };
                });
                return data;
            }
        };
        return deep(tree);
    };
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScrollx, true);
    }
};
AlarmCenter = __decorate([
    Component({
        name: 'SearchFrom',
        components: { FilterBar, VirtualList, ContainImg, DetailsPage },
        i18n: { sharedMessages: langMsg },
    })
], AlarmCenter);
export default AlarmCenter;
